import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.AtomWarlock,
  voices: {
    main: {
      description:
        "serene cosmic tenor, luminous devotional calm, ageless mentor warmth, slow precise phrasing, wide celestial reverb and golden breath",
      seed: 10937,
      guidance: 0.76,
      loudness: 0.78,
      fx: { reverb: 0.28, eq: "warm" },
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "I will bring peace to this universe, no matter the cost.",
      },
      { id: "select_2", text: "Atom Warlock is here." },
      { id: "select_3", text: "Warlock remains prepared." },
      { id: "select_4", text: "Atom Warlock awaits." },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "I can feel the presence of the Goddess all around us…",
      },
      { id: "spawn_2", text: "May your winds guide us to victory, Storm." },
      {
        id: "spawn_3",
        text: "Ultron is not here… yet I still feel his presence. I remember it all too well…",
      },
      {
        id: "spawn_4",
        text: "This time, Ultron, your nanobots will not enslave me. They will set us all free!",
      },
      {
        id: "spawn_5",
        text: "A shame that these beings have not yet evolved beyond such petty squabbles…",
      },
      {
        id: "spawn_6",
        text: "Even my cosmic might may not be enough to save this universe.",
      },
      {
        id: "spawn_7",
        text: "Perhaps I should have stayed in my cocoon a bit longer…",
      },
      {
        id: "spawn_8",
        text: "There are threats ahead even greater than what the Dooms have unleashed.",
      },
      {
        id: "spawn_9",
        text: "It is my destiny to lead you to victory. Do not stand in my way.",
      },
      {
        id: "spawn_10",
        text: "Perfection is unattainable. But that should not stop us from trying to achieve it.",
      },
      {
        id: "spawn_11",
        text: "I was born to change humanity for the better. That time has come.",
      },
      {
        id: "spawn_12",
        text: "In a world consumed by darkness, I will gladly be the light.",
      },
      {
        id: "spawn_13",
        text: "I am no golden god. I am simply a man who wishes to use his power for good.",
      },
      {
        id: "spawn_14",
        text: "Where there is evil in this universe, I will be there to balance it.",
      },
      {
        id: "spawn_15",
        text: "I tend to lost souls, like a shepherd tends to his flock.",
      },
      {
        id: "spawn_16",
        text: "I will leave this universe a better place than it was before I was created.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "I am born anew." },
      { id: "respawn_2", text: "I have risen." },
      { id: "respawn_3", text: "Destiny awaits." },
      { id: "respawn_4", text: "There is still so much to do…" },
    ],
    ult_ally: [{ id: "ult_ally", text: "Rise, my friends!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Born again!" }],
    ability2: [
      { id: "ability2_1", text: "Quantum magic!" },
      { id: "ability2_2", text: "The cosmos heals you!" },
      { id: "ability2_3", text: "Healing power!" },
    ],
    ability1: [
      { id: "ability1_1", text: "Stronger together!" },
      { id: "ability1_2", text: "You are not alone." },
      { id: "ability1_3", text: "Your souls, united!" },
    ],
    kill: [
      { id: "kill_1", text: "This was always your fate." },
      { id: "kill_2", text: "Destiny was not kind to you." },
      { id: "kill_3", text: "Cosmic balance is restored." },
      { id: "kill_4", text: "Your time has passed." },
      { id: "kill_5", text: "Flawless." },
      { id: "kill_6", text: "This ends now." },
      { id: "kill_7", text: "Cosmic justice!" },
      { id: "kill_8", text: "Your fate is sealed!" },
    ],
    multikill: [
      { id: "multikill_1", text: "Three down." },
      { id: "multikill_2", text: "I have dealt with three of them." },
      { id: "multikill_3", text: "Three enemies defeated." },
      { id: "multikill_4", text: "That makes five." },
      { id: "multikill_5", text: "Five? Not bad…" },
      { id: "multikill_6", text: "Five foes eliminated." },
      { id: "multikill_7", text: "Another battle ended." },
      { id: "multikill_8", text: "Over so soon?" },
      { id: "multikill_9", text: "Our foes have fallen by my hand." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "I am restored!" },
      { id: "low_hp_2", text: "Just what I required." },
    ],
    healed: [
      { id: "healed_1", text: "I feel better already." },
      { id: "healed_2", text: "My cosmic might returns." },
      { id: "healed_3", text: "Ah, the aid I required…" },
      { id: "healed_4", text: "Healing supplies, at last." },
    ],
  },
} satisfies VoiceScript;

export default script;
